import { render, staticRenderFns } from "./CombinedDocument.vue?vue&type=template&id=43da3be2&"
import script from "./CombinedDocument.vue?vue&type=script&lang=ts&"
export * from "./CombinedDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports